/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>在线用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="keyword" placeholder="输入用户手机号/昵称"></el-input>
        <!-- <el-input size="small" v-model="formInline.machineNo" placeholder="输入邀请人用户手机号"></el-input> -->
      </el-form-item>

      <!-- <el-form-item>
        <el-select size="small" v-model="formInline.statusType" placeholder="请选择">
          <el-option v-for="type in statusType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column sortable prop="id" label="id" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="name" label="头像" width="120"> 

        <template slot-scope="scope">
          <img style="width: 90px;height: 90px;" :src="$adminImageUrl(scope.row.headPortrait)">
        </template>

      </el-table-column>
      <el-table-column sortable prop="username" label="用户昵称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="balance" label="余额" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.balance / 100 }}</div>
        </template>
      </el-table-column>


      <el-table-column sortable prop="realName" label="真实姓名" width="120" show-overflow-tooltip>
      </el-table-column>
       <el-table-column sortable prop="identityCard" label="身份证" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="alipayAccount" label="支付宝" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="bankCard" label="银行卡" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="bankName" label="开户行" width="120" show-overflow-tooltip>
      </el-table-column>
       <el-table-column sortable prop="inviteId" label="邀请人" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="skillCount" label="技能数量" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openMemberSkills(scope.row)">{{ scope.row.skillCount || 0 }}</el-button>
        </template>
      </el-table-column>

      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{transformDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
        <!-- <el-button size="mini" type="success" @click="handleEdit( scope.row)">发送通知</el-button> -->
          <el-button size="mini" type="primary" plain @click="openMemberSkills(scope.row)">查看技能</el-button>
          <el-button size="mini" v-if="scope.row.status!=2" type="danger" @click="setMemberStatus(2, scope.row.id)">冻结</el-button>
          <el-button size="mini" v-if="scope.row.status==2" type="success" @click="setMemberStatus(0, scope.row.id)">解冻</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="用户技能" :visible.sync="memberSkillVisible" width="70%" append-to-body>
      <div v-if="currentMember.id" class="member-summary">
        <div>用户：{{ currentMember.username || '-' }}</div>
        <div>手机号：{{ currentMember.mobile || '-' }}</div>
        <div>技能数：{{ memberSkillList.length }}</div>
      </div>
      <el-table size="small" :data="memberSkillList" border v-loading="memberSkillLoading" element-loading-text="拼命加载中">
        <el-table-column prop="id" label="技能ID" width="90"></el-table-column>
        <el-table-column label="技能分类" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.classifyName || '-' }}</div>
            <div class="sub-text">{{ scope.row.classifyTwoName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="100" align="center">
          <template slot-scope="scope">
            <div>{{ formatMoney(scope.row.price) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.contact || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="电话" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.phone || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'success' : 'warning'" size="mini">
              {{ scope.row.status === 0 ? '开启中' : '已关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="介绍" min-width="260" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.introduce || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="openSkillDetail(scope.row)">详情</el-button>
            <el-button size="mini" type="primary" plain @click="openImagePreview(scope.row, 'skillImage', '技能图/证书图')">技能图</el-button>
            <el-button size="mini" type="success" plain @click="openImagePreview(scope.row, 'workImage', '作品图/视频')">作品图</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="previewVisible" width="760px" append-to-body>
      <div v-if="previewMediaList.length" class="preview-grid">
        <div v-for="(item, index) in previewMediaList" :key="item.url + '-' + index" class="preview-card">
          <video
            v-if="item.type === 'video'"
            class="preview-video"
            :src="getVideoFirstFrameUrl(item.url)"
            preload="auto"
            playsinline
            controls
            muted
            @loadedmetadata="prepareVideoFirstFrame"
            @loadeddata="prepareVideoFirstFrame"
            @seeked="prepareVideoFirstFrame"
          ></video>
          <el-image v-else class="preview-image" :src="item.url" fit="cover">
            <div slot="error" class="preview-empty">加载失败</div>
          </el-image>
          <div class="preview-actions">
            <el-button size="mini" type="text" @click="openImageInNewTab(item.url)">
              {{ item.type === 'video' ? '查看原视频' : '查看原图' }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-else class="preview-no-data">暂无媒体</div>
    </el-dialog>
    <el-dialog title="技能详情" :visible.sync="skillDetailVisible" width="820px" append-to-body>
      <div v-if="skillDetailData" class="detail-wrapper">
        <div class="detail-section">
          <div class="detail-title">基础信息</div>
          <div class="detail-grid">
            <div class="detail-item"><span>技能ID：</span>{{ skillDetailData.id || '-' }}</div>
            <div class="detail-item"><span>分类：</span>{{ formatClassify(skillDetailData) }}</div>
            <div class="detail-item"><span>城市：</span>{{ skillDetailData.desiredCity || '-' }}</div>
            <div class="detail-item"><span>联系人：</span>{{ skillDetailData.contact || '-' }}</div>
            <div class="detail-item"><span>电话：</span>{{ skillDetailData.phone || '-' }}</div>
            <div class="detail-item"><span>技能状态：</span>{{ skillDetailData.status === 0 ? '开启中' : '已关闭' }}</div>
            <div class="detail-item"><span>创建时间：</span>{{ transformDate(skillDetailData.createTime) }}</div>
            <div class="detail-item"><span>更新时间：</span>{{ transformDate(skillDetailData.updateTime) }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">收费信息</div>
          <div class="detail-grid">
            <div class="detail-item"><span>价格：</span>{{ formatMoney(skillDetailData.price) }}</div>
            <div class="detail-item"><span>计费方式：</span>{{ skillDetailData.chargeMode || '-' }}</div>
            <div class="detail-item"><span>工龄：</span>{{ skillDetailData.workingAge || '-' }}</div>
            <div class="detail-item"><span>免费公里：</span>{{ formatDistance(skillDetailData.freeKm) }}</div>
            <div class="detail-item"><span>超出每公里：</span>{{ formatMoney(skillDetailData.chargeKm) }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">技能介绍</div>
          <div class="detail-text">{{ skillDetailData.introduce || '-' }}</div>
        </div>
        <div class="detail-section">
          <div class="detail-title">自定义字段</div>
          <div v-if="getCustomDataList(skillDetailData).length" class="custom-list">
            <div v-for="(item, index) in getCustomDataList(skillDetailData)" :key="(item.name || 'item') + '-' + index" class="custom-item">
              <span>{{ item.name || ('字段' + (index + 1)) }}：</span>{{ item.value || '-' }}
            </div>
          </div>
          <div v-else class="detail-text">暂无自定义字段</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" append-to-body @click='closeDialog("edit")'>
      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="标题" prop="title">
          <el-input size="small" v-model="from.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
             



      </el-form>

      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="简短内容" prop="briefContent">
          <el-input size="small" v-model="from.briefContent" auto-complete="off" placeholder="简短内容"></el-input>
        </el-form-item>
             



      </el-form>


      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="分类名称" prop="roleName">
            <quill-editor
            v-model="from.content"
            :options="editorOption"
            style="height: 200px;"
            ref="QuillEditor">
            </quill-editor>
        </el-form-item>



      </el-form>






      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(0)">发送</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(1)">给所有人发送</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberListOnLine,setMemberStatus,getMemberSkillList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { getVideoFirstFrameUrl, prepareVideoFirstFrame } from '../../utils/videoFirstFrame'





import client from "@/utils/ossClient.js";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];


export default {
  data() {
    return {
      uploadVisible:false,
      cursorIndex: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },


      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      statusType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 1 },
        { key: '冻结', value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      previewVisible: false,
      previewTitle: '图片预览',
      previewMediaList: [],
      skillDetailVisible: false,
      skillDetailData: null,
      memberSkillVisible: false,
      memberSkillLoading: false,
      memberSkillList: [],
      currentMember: {},

      keyword:"",


      from:{
        title:"",
        briefContent:"",
        content:"",
        userId:"",
        sendType:0,

      }


    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getVideoFirstFrameUrl,
    prepareVideoFirstFrame,

    parseJsonArray(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value
      }
      try {
        var parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        if (typeof value === 'string' && /^https?:\/\//.test(value)) {
          return [value]
        }
        return []
      }
    },
    isVideoFile(url) {
      if (!url) {
        return false
      }
      return /\.(mp4|mov|m4v|avi|webm|mkv)$/i.test(String(url).split('?')[0])
    },
    getMediaList(row, field) {
      return this.parseJsonArray(row[field]).map(item => ({
        url: this.$adminImageUrl(item),
        type: this.isVideoFile(item) ? 'video' : 'image'
      }))
    },
    getCustomDataList(row) {
      return this.parseJsonArray(row.customData)
    },
    formatClassify(row) {
      var classify = row.classifyName || ''
      var classifyTwo = row.classifyTwoName || ''
      if (classify && classifyTwo) {
        return classify + ' / ' + classifyTwo
      }
      return classify || classifyTwo || '-'
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return (value / 100).toFixed(2)
    },
    formatDistance(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return value + ' km'
    },
    openImagePreview(row, field, title) {
      this.previewTitle = title
      this.previewMediaList = this.getMediaList(row, field)
      this.previewVisible = true
    },
    openImageInNewTab(url) {
      if (!url) {
        return
      }
      window.open(url, '_blank')
    },
    openSkillDetail(row) {
      this.skillDetailData = Object.assign({}, row)
      this.skillDetailVisible = true
    },
    openMemberSkills(row) {
      this.currentMember = {
        id: row.id,
        username: row.username,
        mobile: row.mobile
      }
      this.memberSkillVisible = true
      this.memberSkillLoading = true
      this.memberSkillList = []
      getMemberSkillList({ userId: row.id }).then((res) => {
        this.memberSkillLoading = false
        if (res.code == 200) {
          this.memberSkillList = res.data.list || []
          return
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      }).catch(() => {
        this.memberSkillLoading = false
      })
    },

    setMemberStatus(status,id) {
      this.loading = true;
      var parameter = {
        status: status,
        id: id,
      };
      setMemberStatus(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.getdata(this.pageparm.currentPage)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },


    //自定义上传方法..
    mainImgUpload(file) {
      var self = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            self.getUrl(res.url);
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },
    getUrl(url) {
      this.uploadVisible = false;
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (url) {
        // 插入图片，res为服务器返回的图片链接地址

        quill.insertEmbed(this.cursorIndex, "image", url);
        // 调整光标到最后
        quill.setSelection(this.cursorIndex + 1);
      } else {
        // 提示上传失败信息
      }
    },



    // 获取数据方法
    getdata(page) {
      this.loading = true;
      var parameter = {
        keyword: this.keyword,
        page: (page - 1) * 20,
      };
      console.log("parameter",parameter)
      getMemberListOnLine(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },


    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getdata(1)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      this.from.userId = row.id;
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
  
}
.member-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #606266;
}
.sub-text {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.preview-card {
  width: 160px;
}
.preview-image {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #f5f7fa;
}
.preview-video {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #000;
  object-fit: cover;
}
.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  color: #909399;
  font-size: 12px;
  background: #f5f7fa;
}
.preview-actions {
  text-align: center;
  margin-top: 4px;
}
.preview-no-data {
  text-align: center;
  color: #909399;
  line-height: 120px;
}
.detail-wrapper {
  max-height: 70vh;
  overflow-y: auto;
}
.detail-section {
  margin-bottom: 20px;
}
.detail-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.detail-grid,
.custom-list {
  display: flex;
  flex-wrap: wrap;
}
.detail-item,
.custom-item {
  width: 50%;
  line-height: 32px;
  color: #606266;
}
.detail-item span,
.custom-item span {
  color: #303133;
  font-weight: 500;
}
.detail-text {
  line-height: 24px;
  color: #606266;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>

 
 

 



// WEBPACK FOOTER //
// src/views/user/onLine.vue